module.exports = __webpack_public_path__ + "static/KatieRetouch-d1f787a72802a9ca4c579e3da3ccd4c6.jpg";